import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import AddressAutocomplete from "@/components/AddressAutocomplete";

export default function NewPropertyDialog({ open, onClose, customerId, customerAddress, onCreated }) {
  const [form, setForm] = useState({ label: "Main property", address: "", latitude: null, longitude: null, notes: "" });
  useEffect(() => {
    if (open) setForm({ label: "Main property", address: customerAddress || "", latitude: null, longitude: null, notes: "" });
  }, [open, customerAddress]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/estimator/properties", {
        customer_id: customerId, ...form, provider: form.latitude != null ? "mapbox" : "manual",
      });
      toast.success("Property saved");
      onCreated(data);
      onClose();
    } catch { toast.error("Failed"); }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="new-property-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl">New property</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>Label</Label>
            <Input value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} required data-testid="property-form-label" />
          </div>
          <div>
            <Label>Address</Label>
            <AddressAutocomplete
              value={form.address}
              onChange={(v) => setForm({ ...form, address: v })}
              onSelect={(p) => setForm({
                ...form,
                address: p.formatted,
                latitude: p.lat,
                longitude: p.lng,
              })}
              data-testid="property-form-address"
            />
          </div>
          <div>
            <Label>Notes</Label>
            <Textarea rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" className="bg-[#FF5A00] hover:bg-[#E04F00] text-white" data-testid="property-form-submit">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
